const sectionCountdownHurryBoxCss = `
[data-type='section-countdown-hurry-box'] [data-attribute='section-countdown-hurry-box'] {
  padding-top: var(--padding-top-desktop, 0);
  padding-bottom: var(--padding-bottom-desktop, 0);
}

@container (max-width: 768px) {
  [data-type='section-countdown-hurry-box'] [data-attribute='section-countdown-hurry-box'] {
    padding-top: var(--padding-top-mobile, 0);
    padding-bottom: var(--padding-bottom-mobile, 0);
  }
}

[data-type='section-countdown-hurry-box'] .left-in-stock {
  display: flex;
  align-items: center;
  margin-bottom: 8px;
}

[data-type='section-countdown-hurry-box'] .left-in-stock img {
  display: block;
  width: 30px;
  height: auto;
  margin-right: 8px;
}

[data-type='section-countdown-hurry-box'] .left-in-stock [data-attribute='left-in-stock-number'] {
  display: inline-block;
  padding: 0 4px;
}

[data-type='section-countdown-hurry-box'] .people-are-viewing {
  display: flex;
  align-items: center;
  margin-bottom: 8px;
}

[data-type='section-countdown-hurry-box'] .people-are-viewing img {
  display: block;
  width: 30px;
  height: auto;
  margin-right: 8px;
}

[data-type='section-countdown-hurry-box'] .people-are-viewing [data-attribute='people-are-viewing-number'] {
  display: inline-block;
  padding-right: 4px;
}

[data-type='section-countdown-hurry-box'] .last-minute-sale-end-in .time-countdown {
  font-size: 20px;
  color: red;
}
`;
export default sectionCountdownHurryBoxCss;
